function closeHPnews() {
    var showText = $("#newsBox .down").data('showtext');
    $("#newsBox").animate({left:"-430px"},1000);
    $(".newsHp-show").removeClass("hideNews").addClass("showNews");
    $(".down span").text(showText);
}

(function($){

    $(window).load(function(e) {
        var newsHPTimeout = setTimeout(function(f) {
            closeHPnews();
        }, 2000);

        $(document).on('mouseover', '#newsBox', function() {
            window.clearTimeout(newsHPTimeout);
        });
    });

    $(document).on('click', '.hideNews', function(e) {
        e.stopPropagation();
        closeHPnews();
    });

    $(document).on('click','.showNews', function(f) {
        f.stopPropagation();
        var hideText = $("#newsBox .down").data('hidetext');
        $("#newsBox").animate({left:"0"},1000);
        $(".newsHp-show").removeClass("showNews").addClass("hideNews");
        $(".down span").text(hideText);
    });


    function scrollToHome(number) {
        var $target = $(".home__content--" + number);

        $(window).scrollTo($target, 1000, {
            interrupt: true,
            offset: {
                left: 0,
                top: -15
            }
        });
    }

    $(".home__circle").click(function(event) {
        var number = $(this).attr('class').slice(-1);
        
        scrollToHome(number);
    });

    $(".home__btn--whySanus").click(function(event) {
        var headerHeight = $(".header").outerHeight();
        event.preventDefault();

        $(window).scrollTo($(".whyGennet"), 1000, {
            interrupt: true,
            offset: {
                left: 0,
                top: -(headerHeight + 40)
            }
        });
    });

    $(".home__btn--back").click(function(event) {
        event.preventDefault();
        scrollToHome(1);
    });

    $(".home__moreButton--back").click(function(event) {
        event.preventDefault();
        scrollToHome(1);
    });

    if ($(".home__left")) {
        $(".home__left").each(function(index, el) {
            var mih = $(this).next(".home__right").outerHeight();
            $(this).css({
               "height": mih
            }); 
        });

        $( window ).resize(function() {
            $(".home__left").each(function(index, el) {
                var mih = $(this).next(".home__right").outerHeight();
                $(this).css({
                   "height": mih
                }); 
            });
        }); 
    }
}(jQuery));